// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__khw2o","imageUploader":"EGiftCard_imageUploader__2A3lq"};